import React, { useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import { Formik, Form } from 'formik';
import { FormField } from '../components/FormField';
import { compose, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications/dist/ToastProvider';
import gql from 'graphql-tag';
import { MaskInput } from '../components/async/SharedComponents';
import TextInput from '../components/TextInput';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;

const MUTATION = gql`
  query adminGetResetToken($id: String!) {
    adminGetResetToken(id: $id) {
      web {
        resetToken
        resetExpires
      }
      mobile {
        resetToken
        resetExpires
      }
    }
  }
`;

const AdminGetReset = (props) => {
  const [result, setResult] = useState(null);
  const [copiedWeb, setIsCopiedWeb] = useState(false);
  const [copiedMobile, setIsCopiedMobile] = useState(false);
  const handleCopy = async (value, target) => {
    try {
      // Use the Clipboard API to copy the text
      await navigator.clipboard.writeText(value);
      if(target==='mobile'){
      setIsCopiedMobile(true); // Optionally, change state to show feedback (e.g., "Copied!")
}else{
      setIsCopiedWeb(true); // Optionally, change state to show feedback (e.g., "Copied!")
}
      // Optionally reset the copied state after a few seconds
      setTimeout(() => setIsCopiedWeb(false), 2000);
      setTimeout(() => setIsCopiedMobile(false), 2000);
    } catch (error) {
      console.error('Failed to copy: ', error);
    }
  };

  const handleSubmit = async (values, actions) => {
    if (!values.id) return;

    setResult(null);
    actions.setSubmitting(true);
    try {
      const res = await props.client.query({
        query: MUTATION,
        variables: {
          id: values.id,
        },
      });
      // console.log('res', res);

      if (res && res.data && res.data.adminGetResetToken) {
        actions.setSubmitting(false);
        setResult(res.data.adminGetResetToken);
      } else {
        actions.setSubmitting(false);
        // console.log(re)
        props.toastManager.add('No result returned', {
          appearance: 'error',
        });
      }

      actions.setSubmitting(false);
      //   toastManager.add('Error submitting intake form', { appearance: 'error' });
    } catch (err) {
      actions.setSubmitting(false);
      props.toastManager.add('An error occured, please try again', {
        appearance: 'error',
      });
    }
  };

  return (
    <Container>
      <Flex m={[3, 5]} flex={1} flexDirection="column">
        <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
          Get Reset Token
        </Heading>
        <Card mb={4} p={[3, 4]}>
          <Flex flexDirection={'column'} flex={1} alignItems="center">
            <Formik
              initialValues={{ id: '' }}
              // validationSchema={schema}
              onSubmit={(values, actions) => handleSubmit(values, actions)}
              render={({ errors, touched, isValid, isSubmitting, handleChange, handleBlur, values }) => (
                <Form style={{ width: '300px' }}>
                  <Flex flexDirection="column" flex={1}>
                    <Heading mb={4}>Email or Athena ID</Heading>
                  </Flex>
                  <FormField mb={4} error={touched.id && errors.id}>
                    <TextInput style={{ textAlign: 'center' }} name="id" placeholder="Email or Athena ID" />
                  </FormField>

                  <Button mt={4} mb={4} variant="primary" width={1 / 2} disabled={isSubmitting} type="submit">
                    Find
                  </Button>
                </Form>
              )}
            />
          </Flex>
        </Card>
        {!!result && (
          <>
            <Card mb={4} p={[3, 4]}>
              <Flex flexDirection={'column'} flex={1} alignItems="flex-start">
                <Heading mb={4}>Web account:</Heading>
                <Text>
                  Reset Token: <span style={{ fontWeight: 500 }}>{result && result.web ? result.web.resetToken : 'NOT DEFINED'}</span>
                </Text>
                <Text mb={3}>
                  Expires: <span style={{ fontWeight: 500 }}>{result && result.web && result.web.resetExpires ? moment(result.web.resetExpires).format('MM/DD/YYYY HH:mm') : 'NOT DEFINED'}</span>
                </Text>

                <button disabled={!result|| !result.web|| !result.web.resetToken} onClick={() => handleCopy(result.web.resetToken)} style={{ alignSelf: 'center' }}>
                  {copiedWeb ? 'Copied!' : 'Copy to Clipboard'}
                </button>
              </Flex>
            </Card>
            <Card mb={4} p={[3, 4]}>
              <Flex flexDirection={'column'} flex={1} alignItems="flex-start">
                <Heading mb={4}>Mobile account:</Heading>
                <Text>
                  Reset Token: <span style={{ fontWeight: 500 }}>{result && result.mobile ? result.mobile.resetToken : 'NOT DEFINED'}</span>
                </Text>
                <Text mb={3}>
                  Expires:{' '}
                  <span style={{ fontWeight: 500 }}>{result && result.mobile && result.mobile.resetExpires ? moment(result.mobile.resetExpires).format('MM/DD/YYYY HH:mm') : 'NOT DEFINED'}</span>
                </Text>

                <button disabled={!result|| !result.mobile|| !result.mobile.resetToken} onClick={() => handleCopy(result.web.resetToken)} style={{ alignSelf: 'center' }}>
                  {copiedMobile ? 'Copied!' : 'Copy to Clipboard'}
                </button>
              </Flex>
            </Card>
          </>
        )}
      </Flex>
    </Container>
  );
};

export default compose(
  withApollo,
  withToastManager,
)(AdminGetReset);
